import { Button as AntButton, ButtonProps as AntButtonProps } from 'antd';
import React from 'react';

export type ButtonProps = AntButtonProps;

/** Thin wrapper around the Ant Design Button that forwards all props unchanged. */
export const Button: React.FC<ButtonProps> = ({ ...props }) => {
  return <AntButton {...props} />;
};

export default Button;
